var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningRedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9556 777.778C18.0223 777.778 -0.0221944 748.044 18.8222 711.711L365.689 43.8222C384.556 7.4889 415.422 7.4889 434.289 43.8222L781.156 711.733C800.044 748.044 781.978 777.778 741.044 777.778H58.9556Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M346.289 643.4C346.307 629.151 351.976 615.49 362.054 605.416C372.132 595.343 385.795 589.678 400.044 589.667C414.29 589.684 427.947 595.351 438.02 605.424C448.093 615.497 453.76 629.154 453.778 643.4C453.76 657.648 448.094 671.307 438.022 681.384C427.949 691.46 414.292 697.132 400.044 697.156C385.793 697.138 372.13 691.469 362.053 681.391C351.976 671.314 346.307 657.651 346.289 643.4V643.4ZM350.422 236.889C350.422 207.956 371.778 190.044 400.022 190.044C427.6 190.044 449.644 208.644 449.644 236.889V502.178C449.644 530.422 427.6 549.022 400.022 549.022C371.778 549.022 350.422 531.089 350.422 502.178V236.889V236.889Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRedIcon);
export default __webpack_public_path__ + "static/media/warning-red-icon.b91c674f5fc0d0c38e702ff0d82436d7.svg";
export { ForwardRef as ReactComponent };